import React, { Fragment, Component } from 'react';
import { withRouter } from 'react-router';
import { withSnackbar } from 'notistack';
import { Button, Grid, TextField, CircularProgress, Tooltip, Drawer } from '@material-ui/core';
import { LabelValueCard, RevisionHistory, PageLoader, DeletePopUp, CustomChip, CustomDropzone, PreviewDocsModal } from '../../../../shared_elements';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { assetId } from '../../../../constants';
import { capitalizeFirstLetter, checkApiStatus, checkPermission, downloadFile, toastFlashMessage } from '../../../../utils_v2';
import { fieldValidation, dateRangeValidation } from '../../../../utils_v2/formValidation';
import { addEditContributionApi, getContributionApi } from '../apiServices';
import { addContribution, addWetLease, errorCode } from '..';
import { globalDeleteService, globalPostService } from '../../../../utils_v2/globalApiServices';
import { addAttachmentApi, deleteAttachmentApi } from '../../../../shared_elements/apiServices';
import { titanInstance } from '../../../../shared_elements/components';

class ContributionCRU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      formSubmitLoader: false,
      pageLoader: false,
      mode: '',
      contribution: {},
      error: {},
      previewDocs: '',
      deleteAttachmentModal: false,
      deleteItem: null,
      attachedDoc: []
    }
    this.addEditContributionApi = addEditContributionApi.bind(this);
    this.getContributionApi = getContributionApi.bind(this);
  }
  onFieldChange = (event, keyParam, data) => {
    this.setState(prevState => ({
      ...prevState,
      contribution: {
        ...prevState.contribution,
        [keyParam]: data
      }
    }))
  }
  updateErrorField = (key, message) => {
    this.setState(prevState => ({
      ...prevState,
      error: {
        ...prevState.error,
        [key]: message
      }
    }))
  }
  toggleFnc = (key, status) => {
    this.setState({ [key]: status })
  }
  addAttachment = (data) => {
    const { props, params } = this.props;
    const { attachedDoc, contribution } = this.state;
    let formdata = new FormData();

    attachedDoc.forEach(item => {
      formdata.append('files', item);
    });

    formdata.append('asset_type', assetId[params?.type])
    formdata.append('asset_slug', params.aircraft_slug);
    formdata.append('contract_slug', params.contract_slug);
    formdata.append('model_type', '11');
    formdata.append('object_id', data?.data?.id)
    this.setState({ pageLoader: true });
    globalPostService(`contracts/attachments/`, formdata)
      .then(response => {
        if (response.data.statusCode === 200) {
          this.props.getResponseBack();
          toastFlashMessage(data?.message, 'success');
        } else {
          toastFlashMessage(response.data.message, 'error');
        }
        this.setState({ pageLoader: false });
      });
  }
  addEditContributionFn = () => {
    const { contribution } = this.state;
        let validationInputs = {
          component:errorCode['component'][fieldValidation({...errorCode['contributionObj'], fieldval: contribution.component })],
        };
    if(Object.keys(validationInputs).every((k) => { return validationInputs[k] === ''})){
      if (this.state.attachedDoc?.length + contribution?.attachments?.length > 50) {
        this.props.enqueueSnackbar('Only 50 attachment can be attached.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        return;
      }
      this.setState({ formSubmitLoader: true });
      this.addEditContributionApi(this.props, contribution)
        .then(response => {
          this.setState({ formSubmitLoader: false });
          if (checkApiStatus(response)) {
            if (this.state.attachedDoc?.length) {
              addAttachmentApi(response?.data, this.props, this.state.attachedDoc, "21", this.toggleFnc);
              this.setState({ modal: false, mode: '', contribution: {}, error: {} });
            } else {
              this.props.getResponseBack();
              this.props.enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
              this.setState({ modal: false, mode: '', contribution: {}, error: {} });
            }

          } else {
            this.props.enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
          }
        })
      }else{
        this.setState({error: validationInputs});
      }
    }
  previewDoc(item) {
    this.setState({ previewDocs: item })
  }
  handleDelete = (item) => {
    this.setState({ deleteAttachmentModal: true, deleteItem: item });
  };

  deleteAttachment = (item) => {
    const { contribution, deleteItem } = this.state;
    this.setState({ deleteAttachmentModal: false, pageLoader: true });
    globalDeleteService(`contracts/attachments/${deleteItem.uuid}/`)
      .then((response) => {
        this.setState({ pageLoader: false });
        if (response?.data?.statusCode === 200) {
          const updatedPoolingLanguage = contribution.attachments.filter((file) => file.uuid !== deleteItem.uuid);
          this.setState({ contribution: { ...contribution, attachments: updatedPoolingLanguage } });
          this.getContributionApi(this.props, contribution.id)
          toastFlashMessage(response?.data?.message, 'success');
        } else {
          toastFlashMessage(response?.data?.message, 'error');
        }
      })
  };


  getDeleteResponse = () => {
    const { contribution, deleteItem } = this.state
    const updatedAttachments = contribution?.attachments?.filter(
      attachment => attachment.uuid !== deleteItem?.uuid
    );
    this.setState(prevState => ({
      ...prevState,
      contribution: {
        ...prevState.contribution,
        attachments: updatedAttachments
      }
    }))
    this.props.getResponseBack()
  }
  render() {
    const { modal, formSubmitLoader, mode, contribution, error, pageLoader, previewDocs, deleteAttachmentModal } = this.state;
    const { id, m, contractInfo } = this.props;
    return (
      <Fragment>
        {pageLoader ? <PageLoader /> : null}
        {id ?
          <span onClick={() => this.getContributionApi(this.props, id, m)}><Tooltip title="View"><VisibilityIcon color='primary' fontSize='small' style={{ cursor: 'pointer' }} /></Tooltip></span> :
          (contractInfo?.hdlineInfo?.archived_asset == false ?
            <Button onClick={() => this.setState({ modal: true, contribution: addContribution, mode: 'add' })} variant="contained" color="primary"><AddIcon fontSize='small' />Add Contribution</Button>
            : null)
        }
        {modal ?
          <Drawer
            open={modal}
            anchor="right"
            onClose={() => this.setState({ modal: false, mode: '', contribution: {}, error: {} })}
          >
            <div style={{ width: '670px' }} className="drawer-container">
              <div className="drawer-header" alignItems='center'>
                <span className="left-blk">{`${capitalizeFirstLetter(mode)} Contribution`}</span>
                <CloseIcon className="close-icon" onClick={() => this.setState({ modal: false })} />
                {mode !== 'add' ?
                  <ul className="list-inline right-blk">
                    <li className="list-inline-item">
                      <RevisionHistory
                        url='audit/contracts/ctcontribution/'
                        queryParams={{ action: 1, object_id: id }}
                        buttonType={false}
                      />
                    </li>
                    <li className="list-inline-item">
                      {contractInfo?.hdlineInfo?.archived_asset == false ? checkPermission('contracts','contribution', 'U') && mode === 'view' && <span className="cta" onClick={() => this.setState({ mode: 'edit' })}><EditIcon className="edit-icon" />Edit</span> : false}
                      {mode !== 'view' && <span className="cta" onClick={() => this.setState({ mode: 'view' })}><VisibilityIcon className="view-icon" />View</span>}
                    </li>
                  </ul> : null
                }
              </div>
              <div className="drawer-body" style={{ position: "sticky" }}>
                <Grid container spacing={3}>
                    {mode === 'view' ?
                      <LabelValueCard md={12} label="Component" value={contribution?.component ? contribution.component : '--'} /> :
                      <Grid item xs={12}>
                        <TextField
                          required
                          id="component"
                          label="Component"
                          fullWidth
                          margin="normal"
                          value={contribution?.component || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.onFieldChange(e, 'component', e.target.value)}
                          error={error.component ? true:false }
                          helperText={error.component ? error.component: ''}
                          onFocus={(e) => this.updateErrorField('component', '')}
                        />
                      </Grid>
                    }
                    {mode === 'view' ?
                      <LabelValueCard md={12} label="Event" value={contribution?.event ? contribution.event : '--'} /> :
                      <Grid item xs={12}>
                        <TextField
                          id="event"
                          label="Event"
                          fullWidth
                          margin="normal"
                          value={contribution?.event || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.onFieldChange(e, 'event', e.target.value)}
                        />
                      </Grid>
                    }
                    {mode === 'view' ?
                      <LabelValueCard md={12} label="Party" value={contribution?.party ? contribution.party : '--'} /> :
                      <Grid item xs={12}>
                        <TextField
                          id="party"
                          label="Party"
                          fullWidth
                          margin="normal"
                          value={contribution?.party || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.onFieldChange(e, 'party', e.target.value)}
                        />
                      </Grid>
                    }
                    {!titanInstance?<>
                    {mode === 'view' ?
                      <LabelValueCard md={12} label="Type" value={contribution?.type ? contribution.type : '--'} /> :
                      <Grid item xs={12}>
                        <TextField
                          id="type"
                          label="Type"
                          fullWidth
                          margin="normal"
                          value={contribution?.type || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.onFieldChange(e, 'type', e.target.value)}
                        />
                      </Grid>
                    }</>:null}
                    {mode === 'view' ?
                      <LabelValueCard md={12} label="Reference" value={contribution?.reference ? contribution.reference : '--'} /> :
                      <Grid item xs={12}>
                        <TextField
                          id="reference"
                          label="Reference"
                          fullWidth
                          margin="normal"
                          value={contribution?.reference || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.onFieldChange(e, 'reference', e.target.value)}
                        />
                      </Grid>
                    }
                    {!titanInstance?<>
                    {mode === 'view' ?
                      <LabelValueCard md={12} label="Completed" value={contribution?.completed ? contribution.completed : '--'} /> :
                      <Grid item xs={12}>
                        <TextField
                          id="completed"
                          label="Completed"
                          fullWidth
                          margin="normal"
                          value={contribution?.completed || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.onFieldChange(e, 'completed', e.target.value)}
                        />
                      </Grid>
                    }
                    {mode === 'view' ?
                      <LabelValueCard md={12} label="Partly Estimated" value={contribution?.partly_estimated ? contribution.partly_estimated : '--'} /> :
                      <Grid item xs={12}>
                        <TextField
                          id="partly_estimated"
                          label="Partly Estimated"
                          fullWidth
                          margin="normal"
                          value={contribution?.partly_estimated || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.onFieldChange(e, 'partly_estimated', e.target.value)}
                        />
                      </Grid>
                    }
                    {mode === 'view' ?
                      <LabelValueCard md={12} label="Estimated Occurrence" value={contribution?.estimated_occurence ? contribution.estimated_occurence : '--'} /> :
                      <Grid item xs={12}>
                        <TextField
                          id="estimated_occurence"
                          label="Estimated Occurrence"
                          fullWidth
                          margin="normal"
                          value={contribution?.estimated_occurence || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.onFieldChange(e, 'estimated_occurence', e.target.value)}
                        />
                      </Grid>
                    }</>:null}
                    {mode === 'view' ?
                      <LabelValueCard md={12} label="Description" value={contribution?.description ?<span dangerouslySetInnerHTML={{ __html: contribution?.description.replace(/\n/g, '<br />') }} />: '--'} /> :
                      <Grid item xs={12}>
                        <TextField
                          id="description"
                          label="Description"
                          fullWidth
                          multiline
                          rows={4}
                          margin="normal"
                          value={contribution?.description || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.onFieldChange(e, 'description', e.target.value)}
                        />
                      </Grid>
                    }
                  {mode === 'view' ?
                    <div style={{ marginLeft: '8px', marginBottom: '20px' }}>
                      <p style={{ fontSize: '14px', color: 'rgb(160, 160, 160)', fontFamily: "Conv_IBMPlexSans-Regular" }}>Attachment(s) {contribution?.attachments?.length > 0 ? `[Count : ${contribution?.attachments?.length}]` : null}</p>
                      {contribution?.attachments?.length ? contribution?.attachments && contribution?.attachments.map((file, index) => (
                        <CustomChip
                          style={{ marginRight: '4px', marginTop: '7px' }}
                          title={file.name}
                          index={index}
                          label={file.name.substring(0, 14) + '...'}
                          onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ previewDocs: file }) }}
                        />
                      )) : '--'}
                    </div>
                    :
                    (
                      <Grid item xs={12} style={{ marginBottom: '20px' }} className='drag-drop'>
                        <p style={{ fontSize: '13px', color: 'rgb(160, 160, 160)', fontFamily: "Conv_IBMPlexSans-Regular", marginLeft: '8px' }}>Attachment(s)</p>
                        <CustomDropzone
                          onChange={(files) => this.setState({ attachedDoc: files })}
                          componentData={contribution}
                          attachedDoc={this.state.attachedDoc}
                        >
                        </CustomDropzone>
                        {contribution?.attachments && contribution?.attachments.map((file, index) => (
                          <CustomChip
                            style={{ marginRight: '4px', marginTop: '7px' }}
                            title={file.name}
                            index={index}
                            label={file.name.substring(0, 14) + '...'}
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ previewDocs: file }) }}
                            onDelete={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ deleteAttachmentModal: true, deleteItem: file }); }}
                          />
                        ))}
                      </Grid>)}
                </Grid>
              </div>
              <div className="drawer-footer">
                {mode !== 'view' ?
                  <Button onClick={this.addEditContributionFn} color="primary" variant="contained" disabled={formSubmitLoader}>
                    {formSubmitLoader ? <CircularProgress color="#ffffff" size={24} /> : 'Save Changes'}
                  </Button> : null
                }
                <Button onClick={() => this.setState({ modal: false, mode: '', contribution: {}, error: {} })} color="primary" style={mode == 'view' ? { marginLeft: 'auto', paddingLeft: '0px' } : { marginLeft: '8px' }}>Cancel</Button>
              </div>
            </div>
          </Drawer> : null
        }
        {
          this.state.previewDocs ? <PreviewDocsModal previewDocs={this.state.previewDocs} toggleModalFn={() => this.setState({ previewDocs: '' })} /> : null
        }
        {this.state.deleteAttachmentModal ?
          <DeletePopUp
            modal={this.state.deleteAttachmentModal}
            toggleModalFn={() => this.setState({ deleteAttachmentModal: false })}
            title="Delete Attachment"
            content={<h4>Are you sure you want to delete?</h4>}
            deleteRecordFn={() => deleteAttachmentApi(this.state.deleteItem, this.toggleFnc, this.getDeleteResponse)}
          /> : null
        }
      </Fragment>
    )
  }
}
export default withRouter(withSnackbar(ContributionCRU));
